<template>
  <Tpl.define>
    <div
      class="flex flex-col gap-4 bg-green-10 rounded-md items-center text-center border-2 border-dashed border-green-20 relative"
      :class="[size === 'sm' ? 'py-2 px-4' : 'py-4 px-8']"
    >
      <div class="flex flex-col" :class="[titleSecond ? 'w-3/4' : 'w-full']">
        <StellaText
          :type="size === 'sm' ? 'Display Italic XS' : 'Display Italic S'"
          class="font-light"
          :class="[titleSecond && 'text-left']"
        >
          {{ title }}
        </StellaText>
        <StellaText
          v-if="titleSecond"
          :type="size === 'sm' ? 'Display Italic XS' : 'Display Italic S'"
          class="font-light text-right"
        >
          {{ titleSecond }}
        </StellaText>
      </div>
      <StellaText :type="size === 'sm' ? 'Label XS' : 'Label S'">
        {{ body }}
      </StellaText>
      <StellaText
        :type="size === 'sm' ? 'Body XS' : 'Body S'"
        class="underline"
      >
        {{ cta }}
      </StellaText>
      <StellaIcon
        v-if="type === 'referral'"
        icon="cursor"
        class="absolute text-white"
        :class="[size === 'sm' ? 'top-2 right-2' : 'top-4 right-4']"
      />
    </div>
  </Tpl.define>

  <StellaLink
    v-if="type === 'join'"
    class="flex flex-col bg-green-10 rounded-lg text-pink-90 decoration-pink-90 !no-underline hover:opacity-70"
    :class="[size === 'sm' ? 'p-4' : 'p-6', $attrs.class]"
    :to="{ name: 'signup', query: { sp_ft2: 'true' } }"
    v-track="trackingEvent"
    v-track-props="{
      component: trackingComponent,
    }"
  >
    <Tpl.reuse />
  </StellaLink>

  <div
    v-else-if="type === 'referral'"
    class="flex flex-col bg-green-10 rounded-lg text-pink-90 decoration-pink-90 !no-underline cursor-pointer hover:opacity-70"
    :class="[size === 'sm' ? 'p-4' : 'p-8', $attrs.class]"
    @click="copyReferralLink"
    v-track="trackingEvent"
    v-track-props="{
      component: trackingComponent,
    }"
  >
    <Tpl.reuse />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { createReusableTemplate } from '@vueuse/core'
import { useToast } from '/@/core/elements/toast'
import { cbcopy } from '/@/utils/misc'
import { useCurrentDesigner } from '/@/data/designer/current'

const {
  type = 'join',
  size = 'lg',
  trackingComponent,
} = defineProps<{
  type?: 'join' | 'referral'
  size?: 'sm' | 'lg'
  trackingComponent: string
}>()

const { designer } = useCurrentDesigner()
const Tpl = createReusableTemplate()
const toast = useToast()

const title = computed(() => {
  switch (type) {
    case 'referral':
      return 'Loving'
    case 'join':
    default:
      return 'Shop the entire internet in one place.'
  }
})
const titleSecond = computed(() => {
  switch (type) {
    case 'referral':
      return 'Spoak?'
    case 'join':
    default:
      return undefined
  }
})

const body = computed(() => {
  switch (type) {
    case 'referral':
      return `Invite a friend and you'll each get $10 off your membership.`
    case 'join':
    default:
      return 'And get price drop alerts while you’re at it. Free. Forever.'
  }
})

const cta = computed(() => {
  switch (type) {
    case 'referral':
      return 'Copy referral link'
    case 'join':
    default:
      return 'Join now'
  }
})

const trackingEvent = computed(() => {
  switch (type) {
    case 'referral':
      return 'Copy Referral Code Clicked'
    case 'join':
    default:
      return 'Join Spoak Clicked'
  }
})

async function copyReferralLink() {
  await cbcopy(
    `https://www.spoak.com/referral?u=${designer.value?.referralCode ?? designer.value?.nickname}`,
  )
  toast.show({
    type: 'stella',
    message: 'Referral link copied to your clipboard!',
    severity: 'success',
  })
}
</script>
